<script lang="ts">
    import type { WithChild } from "bits-ui";
    import { auth, useSession } from "../auth.svelte.js";
    import Combobox from "./common/combobox.svelte";
    import { m } from "../messages.svelte.js";

    const { child }: WithChild = $props();

    const session = useSession();
    const organizations = auth.useListOrganizations();
</script>

<Combobox
    value={session.session.activeOrganizationId ?? null}
    onSelect={async (x) => {
        await auth.organization.setActive({ organizationId: x });
        window.location.reload();
    }}
    {child}
    placeholder={m["Select organization"]()}
    items={$organizations.data?.sort((a, b) => a.name.localeCompare(b.name)).map((x) => ({ id: x.id, text: x.name })) ??
        []}
/>
